import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, umsUrl, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { INCOMING_SESSION, INCOMING_SESSION_SUCCESS, INCOMING_SESSION_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* getIncomingSession({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/admin/agents/me/transfer/incoming`,
      method: 'GET',
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      yield put({
        type: INCOMING_SESSION_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: INCOMING_SESSION_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: INCOMING_SESSION_ERROR, payload: error });
  }
}

export function* watchIncomingSession() {
  yield takeEvery(INCOMING_SESSION, getIncomingSession);
}

function* watchIncomingSessionSaga() {
  yield all([fork(watchIncomingSession)]);
}

export default watchIncomingSessionSaga;
